import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { aanwezigheidApi } from '../../../lib/aanwezigheidApi';

/**
 * Fetch the composed attendance calendar for `[van, tot]` (Story 4.1's
 * `calendarService`, role-scope resolved server-side). Query-keys-factory
 * per periode (AD-9).
 *
 * `keepPreviousData`: every prev/next/vandaag-click changes the query key.
 * Without it `data` drops to `undefined` between periods, which unmounts
 * the filter bar and momentarily empties the derived department list —
 * making an applied team-filter look like it reset itself on every
 * navigation.
 */
export function useAanwezigheidskalender(van: string, tot: string) {
  return useQuery({
    queryKey: ['aanwezigheidskalender', van, tot],
    queryFn: () => aanwezigheidApi.getCalendar(van, tot),
    staleTime: 1000 * 60 * 5, // 5 min cache, same convention as useTeamSchedules/useAllSchedules
    placeholderData: keepPreviousData,
    enabled: !!van && !!tot,
  });
}
